import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/main/dashboard/dashboard.service';
import { statusCode } from 'app/auth/models/commonEnum';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-apply-for-funding',
  templateUrl: './apply-for-funding.component.html',
  styleUrls: ['./apply-for-funding.component.scss']
})
export class ApplyForFundingComponent implements OnInit {
  public contentHeader;
  dashboardCount: any[] = [];
  documentURL: any;
  constructor(private _dashboardService: DashboardService,) { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Apply For Funding',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Apply For Funding',
            isLink: true,
            link: '/apply-for-funding'
          }
        ]
      }
    };
    this.getDashboardCount();
    this.documentURL = environment.documentURL;
  }
  // get dashboard count
  getDashboardCount() {
    this._dashboardService.getDashboardDetails().subscribe((result: any) => {
      if (result.statusCode == statusCode.SUCCESS) {
        this.dashboardCount = result["data"]["response"];
        // console.log(this.dashboardCount);
      }
    })
  }

}
